import React from 'react'

const CentroIdiomas = () => {
  return (
    <div>CentroIdiomas</div>
  )
}

export default CentroIdiomas